'use strict';
var $ = require('jquery');

$(function () {

    var postpage = 1;
    var maxpages = 0;
    var getpages = 0;
    var pastpostpage = 0;
    var pastpostpagesuccess = 0;

    if ($('body.page-template-news-archives').length) {

        function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }

        function isNumeric(str) {
            if (typeof str != "string") return false;
            return !isNaN(str) && !isNaN(parseFloat(str));
        }

        var pageNumber = findGetParameter('pageNumber');

        if (pageNumber === null) {
            pageNumber = 1;
            var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + `?pageNumber=${postpage}`;
            window.history.pushState({ path: refresh }, '', refresh);
            var popStateEvent = new PopStateEvent('popstate', { path: refresh });
            dispatchEvent(popStateEvent);
        }

        if (isNumeric(pageNumber) && pageNumber.length < 2) {
            updatePagination();
        }

        postpage = parseInt(pageNumber);

        window.addEventListener('popstate', (event) => {
            postpage = findGetParameter('pageNumber');
            get_posts_per_page(false);
            updatePagination(postpage);
        });

        function hide_arrows() {
            var maxpage = $('.pagination-arrow.up').data('maxpage');
            if (postpage >= maxpage) {
                $('.pagination-arrow.up').hide();
            } else {
                $('.pagination-arrow.up').show();
            }
            if (postpage < 2) {
                $('.pagination-arrow.down').hide();
            } else {
                $('.pagination-arrow.down').show();
            }
        }
        hide_arrows();

        function swich_page(buttonpage) {
            var btn = buttonpage.data('pegenation');
            if (postpage != btn) {
                postpage = btn;
                get_posts_per_page();
                $('.pagenation-number').removeClass('active');
                $(buttonpage).addClass('active');
                hide_arrows();
            }
        }

        function swich_page_with_arrow(buttonpage) {
            var btn = buttonpage.data('pegenation');
            if (btn == "up") {
                postpage += 1;
                $('.pagenation-number').removeClass('active');
                get_posts_per_page();
                $('.pagenation-number[data-pegenation=' + postpage + ']').addClass('active');
                hide_arrows();
            } else {
                postpage -= 1;
                $('.pagenation-number').removeClass('active');
                get_posts_per_page();
                $('.pagenation-number[data-pegenation=' + postpage + ']').addClass('active');
                hide_arrows();
            }
        }

        // Add touch support for click events
        $('.pagenation-number').on('click touchstart', function () {
            swich_page($(this));
        });
        $('.pagination-arrow').on('click touchstart', function () {
            swich_page_with_arrow($(this));
        });

        $('.lds-ripple').hide();

        function updatePagination(page = pageNumber) {
            $('.pagenation-number').removeClass('active');
            $('.pagenation-number[data-pegenation=' + page + ']').addClass('active');
        }

        // Reset the full page scaling to ensure no unintended zoom occurs
        function resetContentScaling() {
            document.body.style.transform = 'none';  // Removes any body scaling/transform
            document.body.style.zoom = '100%';       // Ensures zoom level is 100%
            $('html, body').css({
                'width': '100%',
                'transform': 'none',
                'zoom': '1',
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        function get_posts_per_page(updateUrl = true) {
            $.ajax({
                url: page.admin_ajax,
                dataType: 'json',
                type: 'POST',
                data: {
                    action: 'postsperpage',
                    postpage: postpage,
                },
                beforeSend: function () {
                    $('.lds-ripple').show();
                    if (postpage > pastpostpage) {
                        $('.news-partial').addClass("ani-way");
                    } else {
                        $('.news-partial').addClass("ani-way-left");
                    }
                    pastpostpage = postpage;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                },
                success: function (data) {
                    $('.lds-ripple').hide();
                    $('.news-content').empty();
                    $('.news-content').append(data['html']);
                    resetContentScaling();  // Reset full page scaling after loading new content

                    var testElement = $('.article');
                    var i = 0
                    function pageani(v) {
                        i++;
                        var reversed = JSON.parse(JSON.stringify(v)).reverse();
                        if (i < 2) {
                            $(v[0]).animate(v[1], {
                                duration: 400,
                                step: function (val) {
                                    testElement.css("transform", `translateX(${val}px)`);
                                },
                                done: function () {
                                    pageani(reversed);
                                }
                            });
                        }
                    };
                    if (postpage > pastpostpagesuccess) {
                        pageani([{ y: 400 }, { y: 0 }]);
                    } else {
                        pageani([{ y: -400 }, { y: 0 }]);
                    }
                    pastpostpagesuccess = postpage;
                    maxpages = data['newspages'];
                    getpages = 1;
                    if (updateUrl) {
                        var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + `?pageNumber=${postpage}`;
                        window.history.pushState({ path: refresh }, '', refresh);
                    }
                }
            });
        }
    }
});
